import React from "react";
import { Box, Typography, Container, Paper } from '@mui/material';
import EmsNavbar from './EmsNavbar';

const Home = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
        }}>
            <EmsNavbar />
            <Box component="main" sx={{
                flex: '1 0 auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', // Vertical centering
                alignItems: 'center',     // Horizontal centering
                py: 4,
                mb: 10
            }}>
                <Container maxWidth="lg" sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',   // Center children horizontally
                    justifyContent: 'center' // Center children vertically
                }}>
                    <Paper elevation={3} sx={{
                        padding: 2,
                        mb: 4,
                        width: '100%',     // Ensure full width within container
                        maxWidth: '800px'  // Optional: Set a max width for better readability
                    }}>
                        <Typography
                            variant="h3"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',
                                color: '#1976d2',
                                fontSize: { xs: '2rem', md: '3rem' },
                                textAlign: 'center',
                                mt: 2,
                                mb: 2
                            }}
                        >
                            Microart Online
                        </Typography>
                        <hr />
                        <Typography variant="body1" sx={{ color: '#555', textAlign: 'center' }}>
                            Welcome to <strong>Microart Online</strong> official platform. Manage your events, abstracts,
                            workshops, and exhibitions all in one place.
                            <br />
                            Visit:{" "}
                            <a
                                href="https://microartonline.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#1976d2', textDecoration: 'none' }}
                            >
                                microartonline.com
                            </a>
                        </Typography>
                    </Paper>
                    <Paper elevation={3} sx={{
                        padding: 2,
                        width: '100%',
                        maxWidth: '800px'
                    }}>
                        <Typography
                            variant="h4"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',
                                color: '#1976d2',
                                fontSize: { xs: '1.5rem', md: '2rem' },

                            }}
                        >
                            Features
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#555', }}>
                            - Event Registration<br />
                            - Abstract Submission<br />
                            - Workshops Management<br />
                            - Exhibition Management<br />
                        </Typography>
                        <Typography
                            variant="h4"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',
                                color: '#1976d2',
                                fontSize: { xs: '1.5rem', md: '2rem' },
                                mt: 4,

                            }}
                        >
                            Contact Us
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#555', textAlign: 'center' }}>
                            For any inquiries, please reach out to us at:{" "}
                            <a
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=microartonline@gmail.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#1976d2', textDecoration: 'none' }}
                            >
                                microartonline@gmail.com
                            </a>
                            {" "} or WhatsApp:{" "}
                            <a
                                href="https://wa.me/00966508294744"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#25D366', textDecoration: 'none', fontWeight: 'bold' }}
                            >
                                +966 50 829 4744
                            </a>
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#555', textAlign: 'center', mt: 2 }}>
                            For any technical support kindly WhatsApp:{" "}
                            <a
                                href="https://wa.me/00966565612058"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#25D366', textDecoration: 'none', fontWeight: 'bold' }}
                            >
                                +966 56 561 2058
                            </a>
                        </Typography>
                    </Paper>
                </Container>
            </Box>

            {/* Footer */}
            <Box component="footer" sx={{
                py: 3,
                px: 2,
                mt: 'auto',
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800]
            }}>
                <Container maxWidth="lg">
                    <Typography variant="body2" color="text.secondary" align="center">
                        © {new Date().getFullYear()} Microart Online. All rights reserved.
                    </Typography>
                </Container>
            </Box>
        </Box>
    );
};

export default Home;